import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DashboardModule } from './components/dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { CollegeDetailsModule } from './components/college-details/college-details.module';

import { StudentDetailsModule } from './components/student-details/student-details.module';

import { MediaModule } from './components/media/media.module';

import { AuthModule } from './components/auth/auth.module';

import { SettingModule } from './components/setting/setting.module';
import { UsersModule } from './components/users/users.module';
import { StreamModule } from './components/stream/stream.module';
import { BranchModule } from './components/branch/branch.module';
import { UniversityModule } from './components/university/university.module';
import { RankingsModule } from './components/rankings/rankings.module';
import { OnlineexamModule } from './components/onlineexam/onlineexam.module';
import { DegreeModule } from './components/degree/degree.module';
import { ProgramtypeModule } from './components/programtype/programtype.module';
import { TypeofcollegeModule } from './components/typeofcollege/typeofcollege.module';
import { GenderacceptedModule } from './components/genderaccepted/genderaccepted.module';
import { PermissionsModule } from './components/permissions/permissions.module';
import { SpecializationModule } from './components/specialization/specialization.module';
import { CourseModule } from './components/course/course.module';
import { CoursedurationModule } from './components/courseduration/courseduration.module';
import { CastecategoryModule } from './components/castecategory/castecategory.module';
import { ModulesModule } from './components/modules/modules.module';
import { FacilitiesModule } from './components/facilities/facilities.module';
import { CountryModule } from './components/country/country.module';
import { StateModule } from './components/state/state.module';
import { CityModule } from './components/city/city.module';
import { RoundsModule } from './components/rounds/rounds.module';
import { ApprovedByModule } from './components/approved-by/approved-by.module';
import { KeywordsModule } from './components/keywords/keywords.module';
import { OwnershipModule } from './components/ownership/ownership.module';
import { TagsModule } from './components/tags/tags.module';
import { AmenitiesModule } from './components/amenities/amenities.module';
import { AccreditionsModule } from './components/accreditions/accreditions.module';
import { ListingsModule } from './components/listings/listings.module';

import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { fakeBackendProvider } from './_helper/fake-backend';
import { JwtInterceptor } from './_helper/jwt.interceptor';
import { ErrorInterceptor } from './_helper/error.interceptor';
import { LoginComponent } from './components/auth/login/login.component';
import * as $ from 'jquery';
import { ToastComponent } from './components/toastr/toast.component';



const api_endpoint = 'http://localhost:3003/v3';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ToastComponent

  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    AppRoutingModule,
    DashboardModule,
    AuthModule,
    SharedModule,
    CollegeDetailsModule,
    StudentDetailsModule,
    DegreeModule,
    SettingModule,
    MediaModule,
    UsersModule,
    StreamModule,
    PermissionsModule,
    SpecializationModule,
    CourseModule,
    CountryModule,
    StateModule,
    CityModule,
    ApprovedByModule,
    KeywordsModule,
    OwnershipModule,
    TagsModule,
    AmenitiesModule,
    AccreditionsModule,
    ListingsModule,
    BranchModule,
    UniversityModule,
    RankingsModule,
    OnlineexamModule,
    ProgramtypeModule,
    TypeofcollegeModule,
    GenderacceptedModule,
    CoursedurationModule,
    CastecategoryModule,
    ModulesModule,
    FacilitiesModule,
    RoundsModule,
 
  ],
  providers: [
    {provide: 'API_ENDPOINT', useValue: api_endpoint},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    // fakeBackendProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
